import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout from '@/components/Layout';
import { RouteGuard } from '@/components/RouteGuard';
import Dashboard from '@/pages/dashboard';
import DevConfig from '@/pages/dev-config';
import EcommerceQrcode from '@/pages/ecommerce-qrcode';
import FileUpload from '@/pages/file-upload';
import Login from '@/pages/login';

export const router = createBrowserRouter([
	{
		path: 'login',
		element: <Login />,
	},
	{
		path: '/',
		element: (
			<RouteGuard>
				<MainLayout />
			</RouteGuard>
		),
		children: [
			{
				index: true,
				element: <Navigate to="/dashboard" replace />,
			},
			{
				path: 'dashboard',
				element: <Dashboard />,
			},
			{
				path: 'file-upload',
				element: <FileUpload />,
			},
			{
				path: 'ecommerce-qrcode',
				element: <EcommerceQrcode />,
			},
			{
				path: 'dev-config',
				element: <DevConfig />,
			},
			{
				path: 'settings',
				element: <div>系统设置页面（待开发）</div>,
			},
		],
	},
	{
		path: '*',
		element: <Navigate to="/dashboard" replace />,
	},
]);
